import { AttributeProps } from 'src/components/conteudoProdutos/types'
import { ProductCombinationValueSlug } from './enums/product-combination-value-slug'

export const isValidColorBySlug = (colorSlug?: string): boolean => {
  return !!colorSlug && colorSlug !== ProductCombinationValueSlug.NoColor
}

export const isValidVoltageBySlug = (voltageSlug?: string): boolean => {
  return !!voltageSlug && voltageSlug !== ProductCombinationValueSlug.NoVoltage
}

export const isUniqueVoltageSlug = (slug?: string): boolean => {
  return [
    ProductCombinationValueSlug.NoVoltage,
    ProductCombinationValueSlug.Bivolt,
    ProductCombinationValueSlug.Quadriband,
  ].some((uniqueVoltageSlug) => uniqueVoltageSlug === slug)
}

export const isMultiVoltageSlug = (slug?: string): boolean => {
  return [
    ProductCombinationValueSlug.Voltage110,
    ProductCombinationValueSlug.Voltage220,
  ].some((uniqueVoltageSlug) => uniqueVoltageSlug === slug)
}

export const filterSelectableVoltages = (
  voltages: AttributeProps[]
): AttributeProps[] =>
  voltages.filter((voltage) => isMultiVoltageSlug(voltage.slug))
